import { assignTyped } from '../utilities/type-converter';

export default abstract class AbstractComponent {
    protected assignConfig<T>(baseConfig: T, sourceConfig?: { [key: string] : any; }, defaultConfig?: { [key: string] : any; }, strict?: boolean): T {
        return assignTyped(baseConfig, sourceConfig, defaultConfig);
    }
}
